<greco-simple-dialog [data]="dialogData">
  <iframe type="application/pdf" [src]="pdfData" title="dialogData.title"> </iframe>
</greco-simple-dialog>
